import { render } from "./DistributionTable.vue?vue&type=template&id=22ee9f94&scoped=true"
import script from "./DistributionTable.vue?vue&type=script&lang=js"
export * from "./DistributionTable.vue?vue&type=script&lang=js"

import "./DistributionTable.vue?vue&type=style&index=0&id=22ee9f94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ee9f94"]])

export default __exports__